//--------------------------------------------------
// Base API helper
//--------------------------------------------------

const API_BASE_URL = process.env.REACT_APP_API_URL as string;

async function getToken() {
  return window.getIdToken ? window.getIdToken() : null;
}

export class ApiError extends Error {
  status: number;
  data: unknown;

  constructor(status: number, message: string, data: unknown) {
    super(message);
    this.name = 'ApiError';
    this.status = status;
    this.data = data;
  }
}

export async function apiFetch(path: string, options: RequestInit = {}) {
  const token = await getToken();
  const extraHeaders = options.headers ? Object.fromEntries(new Headers(options.headers).entries()) : {};

  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
    ...extraHeaders,
  };

  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  const res = await fetch(`${API_BASE_URL}${path}`, {
    ...options,
    headers,
  });

  // Try to parse JSON even on errors
  const data = await res.json().catch(() => null);

  if (!res.ok) {
    throw new ApiError(
      res.status,
      data?.error || data?.message || `API request failed with status ${res.status}`,
      data
    );
  }

  return data;
}
